<p-calendar [(ngModel)]="dateValue" [minDate]="minDate" [maxDate]="maxDate" (onSelect)="onSelect($event)" [view]="view" [dateFormat]="dateFormat" [showIcon]="true" [readonlyInput]="true" inputStyleClass="w-9rem"></p-calendar>
